import { render, staticRenderFns } from "./ListaPacks.vue?vue&type=template&id=3ab19d61"
import script from "./ListaPacks.vue?vue&type=script&lang=js"
export * from "./ListaPacks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports